module.exports = __webpack_public_path__ + "img/206.da3cf2e2.png";